import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BtnTheme } from '../../type/btnTheme.type';
import { FontWeight } from '../../type/fontWeight.type';
import { BtnType } from '../../type/btnType.type';

@Component({
  selector: 'app-flat-btn',
  templateUrl: './flat-btn.component.html',
  styleUrls: ['./flat-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlatBtnComponent {
  @Input('color') color: string = '';
  @Input('text') text: string = 'Placeholder';
  @Input('theme') theme: BtnTheme;
  @Input('uppercase') uppercase: boolean = true;
  @Input('disabled') disabled: boolean = false;
  @Input('fontWeight') fontWeight: FontWeight = 400;
  @Input('type') type: BtnType = 'button';
}